export default "__VITE_ASSET__CJc4TYvD__"